import { render, staticRenderFns } from "./formEvent.vue?vue&type=template&id=5c88ee58&"
import script from "./formEvent.vue?vue&type=script&lang=js&"
export * from "./formEvent.vue?vue&type=script&lang=js&"
import style0 from "./formEvent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports